'use client';
import CustomToolTip from '@/components/shared/tool-tip/tool-tip.component';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import { AltertTriangle } from '../../../../public/Images';
import styles from './styles.module.scss';
import Image from 'next/image';

interface IStepperRadioButton {
  selected: boolean;
  showAlert: boolean;
  icon: string;
  value: string;
  buttonClicked: (value: string) => void;
  radioGroup: string;
  id: string;
}

const StepperRadioButton = ({
  selected,
  showAlert,
  icon,
  value,
  buttonClicked,
  radioGroup,
  id,
}: IStepperRadioButton) => {
  const { t } = useTranslation();
  return (
    <button
      id={`radioButton_${id}`}
      onClick={() => buttonClicked(value)}
      className={`${styles.radio_button} ${selected ? styles.active : ''}`}
    >
      <div className={styles.radio_button_content}>
        {icon !== '' && <Image width={23} height={23} src={icon} alt={value} />}
        <div
          style={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          <Typography color={'#101828'} variant="body2">
            {value}
          </Typography>
        </div>
      </div>
      <div className={styles.radio_button_content} style={{ gap: '16px' }}>
        {showAlert && (
          <CustomToolTip
            bgColor="#101828"
            color="white"
            title={
              <Typography variant="captionMedium">
                {t('Not Included in Sylndr Shopping List')}
              </Typography>
            }
          >
            <Image width={23} height={23} src={AltertTriangle} alt="Not Available" />
          </CustomToolTip>
        )}
        <input
          className={styles.radio_button_input}
          readOnly
          type="radio"
          name={radioGroup}
          checked={selected}
        />
      </div>
    </button>
  );
};
export default StepperRadioButton;
